import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';
import { withRenderFlag } from '@beef/react';
import { getFTTBServiceError } from '../../../../../../store/selectors';
import { ErrorStatus } from '../../../../components';

export const ServiceErrorConnected = compose(
  connect((state) => ({
    shouldRender: !isEmpty(getFTTBServiceError(state)),
    error: getFTTBServiceError(state),
  })), withRenderFlag,
)(ErrorStatus);
